"use strict";
/**
 * 股票回购详情页
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
require("../../src/modules/singlestocktop/web");
var webconfig = require("../../config/web.js");
var utils_1 = __importDefault(require("../../src/modules/commonutil/utils"));
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
function getValOrEmpty(val, pointNum, divied) {
    return val == null ? "-" : pointNum ? (val / divied).toFixed(pointNum) : val;
}
;
(function ($) {
    var gphg = {
        init: function () {
            this.getTableData();
            this.getZxggData();
            this.eventFn();
        },
        eventFn: function () {
            var _this = this;
            $("#filter").on('click', 'li', function () {
                $(this).addClass('at').siblings().removeClass('at');
                var currentDate = $(this).text();
                _this.toggleDate(currentDate);
            });
            $(".dataview").on('mouseover mouseout', '.icon_faq', function (e) {
                $(".priceexplain").toggle();
            });
        },
        getTableData: function () {
            var _this = this;
            $.ajax({
                url: webconfig.getWebPath("datacenter") + "api/data/v1/get",
                type: "GET",
                dataType: "jsonp",
                data: {
                    reportName: 'RPTA_WEB_GETHGDETAIL',
                    columns: "ALL",
                    sortColumns: 'DIM_DATE',
                    sortTypes: -1,
                    source: 'WEB',
                    filter: '(DIM_SCODE="' + stockInfo.code + '")'
                }
            }).then(function (res) {
                if (res && res.code == 0) {
                    var data = res.result.data;
                    if (data) {
                        var currentDate_1 = fieldtools_1["default"].dateformat(curDateTime);
                        var dateList_1 = [];
                        data.forEach(function (item) {
                            var DIM_DATE = utils_1["default"].dateFormat(item.DIM_DATE);
                            dateList_1.push("<li class=" + (DIM_DATE == currentDate_1 ? "at" : "") + ">" + DIM_DATE + "<i></i></li>");
                            if (DIM_DATE == currentDate_1) {
                                _this.fillDetailData(item);
                            }
                        });
                        $("#filter").html(dateList_1.join(''));
                        $("#selectDate").html("(" + currentDate_1 + ")");
                    }
                }
            }).fail(function (err) {
                console.log(err);
            });
        },
        fillDetailData: function (retData) {
            $(".stockCode").text(retData.DIM_SCODE);
            $(".stockName").text(retData.SECURITYSHORTNAME);
            var star = retData.SFFHSP == 0 ? "*" : "";
            $(".newPrice").text(getValOrEmpty(retData.NEWPRICE, 2, 1) + star);
            $(".closePrice").text(getValOrEmpty(retData.CPRICE, 2, 1));
            $(".priceMinimum").text(getValOrEmpty(retData.REPURPRICELOWER, 2, 1)); //回购价格下限
            $(".priceMaximum").text(getValOrEmpty(retData.REPURPRICECAP, 2, 1));
            $(".numMinimum").text(utils_1["default"].FixAmt(retData.REPURNUMLOWER)); //回购数量下限
            $(".numMaximum").text(utils_1["default"].FixAmt(retData.REPURNUMCAP));
            $(".amountMinimum").text(utils_1["default"].FixAmt(retData.REPURAMOUNTLOWER));
            $(".amountMaximum").text(utils_1["default"].FixAmt(retData.REPURAMOUNTLIMIT)); //回购金额上限
            $(".yhgxx").text(getValOrEmpty(retData.REPURPRICELOWER1, 2, 1)); //已回购价格下限
            $(".yhgsx").text(getValOrEmpty(retData.REPURPRICECAP1, 2, 1)); //已回购价格上限
            $(".yhgsl").text(utils_1["default"].FixAmt(retData.REPURNUM)); //已回购股份数量
            $(".yhgje").text(utils_1["default"].FixAmt(retData.REPURAMOUNT)); //已回购金额
            $(".date").text(utils_1["default"].dateFormat(retData.DIM_DATE)); //回购公告日
            $(".type").text(utils_1["default"].getTextValOrEmpty(retData.SHARETYPE)); //回购股份类型
            $(".ltbl").text(utils_1["default"].getValRegion(retData.LTSZXX, retData.LTSZSX)); //占公告前一日流通市值比例
            $(".zgbbl").text(utils_1["default"].getValRegion(retData.ZSZXX, retData.ZSZSX)); //占公告前一日总股本比例
            $(".noticeDate").text(utils_1["default"].dateFormat(retData.SHMRSLTNOTICEDATE)); //股东大会决议公告日期
            $(".goal").text(utils_1["default"].getTextValOrEmpty(retData.REPUROBJECTIVE)); //回购目的
            $(".updateDate").text(utils_1["default"].dateFormat(retData.UPD)); //状态更新日期
            $(".startDate").text(utils_1["default"].dateFormat(retData.REPURSTARTDATE)); //回购起始日期
            $(".endDate").text(utils_1["default"].dateFormat(retData.REPURENDDATE)); //回购截止日期
            $(".hint").text(utils_1["default"].getTextValOrEmpty(retData.BZ)); //特别提示
            var process = "";
            switch (retData.REPURPROGRESS) {
                case "001":
                    process = "董事会预案";
                    break;
                case "002":
                    process = "股东大会通过";
                    break;
                case "003":
                    process = "股东大会否决";
                    break;
                case "004":
                    process = "实施中";
                    break;
                case "005":
                    process = "停止实施";
                    break;
                case "006":
                    process = "完成实施";
                    break;
                default:
            }
            $(".schedule").text(process); //实施进度
            $(".sftqwc").text(retData.REPURADVANCEDATE ? "是" : "否"); //回购是否提前完成
            $(".tqDate").text(utils_1["default"].dateFormat(retData.REPURADVANCEDATE)); //提前完成日期
            $(".ggqzdf").html(utils_1["default"].getColorByData(retData.RCHANGE20DCP)); //公告前20日涨跌幅
            $(".gghzdf").html(utils_1["default"].getColorByData(retData.RCHANGE20DC)); //公告后20日涨跌幅
            $(".hgwcqzdf").html(utils_1["default"].getColorByData(retData.RCHANGE20DCP_CP)); //回购完成前20日涨跌幅
            $(".hgwchzdf").html(utils_1["default"].getColorByData(retData.RCHANGE20DC_CP)); //回购完成后20日涨跌幅       
        },
        toggleDate: function (currentDate) {
            var _this = this;
            $.ajax({
                url: webconfig.getWebPath("datacenter") + "api/data/v1/get",
                type: "GET",
                dataType: "jsonp",
                data: {
                    reportName: 'RPTA_WEB_GETHGDETAIL',
                    columns: "ALL",
                    sortColumns: 'DIM_DATE',
                    sortTypes: -1,
                    source: 'WEB',
                    filter: "(DIM_SCODE=\"" + stockInfo.code + "\")(DIM_DATE='" + currentDate + "')"
                }
            }).then(function (res) {
                if (res && res.code == 0) {
                    var data = res.result.data[0];
                    if (data) {
                        _this.fillDetailData(data);
                    }
                }
            }).fail(function (err) {
                console.log(err);
            });
        },
        getZxggData: function () {
            var _this = this;
            $.ajax({
                type: 'get',
                url: "/dataapi/stockdata/zxgg?code=" + stockInfo.hqCode
            }).then(function (data) {
                var zixun = data.zixun.data;
                var gonggao = data.gonggao.data;
                var wendongmi = data.wendongmi.data;
                var yanbao = data.yanbao.data;
                // 渲染数据
                $('#zixun').html(_this.zxgghtml(zixun, 'zixun'));
                $('#gonggao').html(_this.zxgghtml(gonggao, 'gonggao'));
                $('#wendongmi').html(_this.zxgghtml(wendongmi, 'wendongmi'));
                $('#yanbao').html(_this.zxgghtml(yanbao, 'yanbao'));
            }).fail(function (err) {
                console.log(err);
            });
        },
        // 资讯公告-渲染html
        zxgghtml: function (data, type) {
            if (data && data.length > 0) {
                return data.map(function (item) { return ("\n                    <li>\n                    <span class=\"dot\">.</span>\n                    <a href=\"" + (type == 'gonggao' ? "/notices/detail/" + stockInfo.code + "/" + item.url + ".html" : item.url) + "\" title=\"" + item.title + "\" class=\"ellipsis\">\n                        " + item.title + "\n                    </a>\n                    <span class=\"time\" title=\"" + item.showTime + "\">" + item.showTime + "</span>\n                    </li>\n                "); });
            }
            else {
                return '<li class="tc" style="height: 70px; line-height: 70px;">暂无相关数据...</li>';
            }
        }
    };
    gphg.init();
})(jQuery);
